import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { MortgageGuideRoutes } from "GenericMortgageGuides";
import Footer from "./components/FooterNew/index";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { HyperlinkProvider } from "./contexts/HyperlinkProvider";

const location = window.location.pathname.toLowerCase();
const baseName = process.env.REACT_APP_BASENAME;
let basePath = baseName === "/heloc" ? `${baseName}/` : baseName;

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      {location === baseName || location === "/heloc/" ? <HyperlinkProvider><App /></HyperlinkProvider> : null}
      {location !== baseName && location !== "/heloc/" && (
        <HyperlinkProvider>
          <MortgageGuideRoutes
            homePath={basePath}
            showHeader={true}
            showFooter={true}
            FooterComponent={Footer}
          />
        </HyperlinkProvider> 
      )}
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
